module.exports = __webpack_public_path__ + "img/home_do.tcl.d8262c05.jpg";